import { render } from "./GenreRecommend.vue?vue&type=template&id=5ff174aa&scoped=true&ts=true"
import script from "./GenreRecommend.vue?vue&type=script&lang=ts"
export * from "./GenreRecommend.vue?vue&type=script&lang=ts"

import "./GenreRecommend.vue?vue&type=style&index=0&id=5ff174aa&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff174aa"]])

export default __exports__